import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';
import BadgesTab from './BadgesTab';
import './scss/tailwind.scss'; // Import seller-badge Tailwind SCSS for dashboard

// Register the BadgesTab component for the vendor tabs
domReady( () => {
    wp.hooks.addFilter(
        'dokan-admin-vendor-tabs',
        'dokan-seller-badge',
        function ( tabs, vendor ) {
            // Add the BadgesTab component to the tabs
            tabs.push( {
                position: 6,
                name: 'badges',
                title: __( 'Badges', 'dokan' ),
                component: () => <BadgesTab vendor={ vendor } />,
            } );

            return tabs;
        }
    );
} );
